import React, { useState } from 'react';
import './ContentSection.css';

const ContentSection = ({ id, type, content, isEditing, onChange }) => {
  const [editValue, setEditValue] = useState(content);
  const [isLocalEditing, setIsLocalEditing] = useState(false);

  const handleSave = () => {
    onChange(editValue);
    setIsLocalEditing(false);
  };

  const handleCancel = () => {
    setEditValue(content);
    setIsLocalEditing(false);
  };

  if (type === 'text') {
    return (
      <section className={`content-section text-section ${isEditing ? 'editable' : ''}`}>
        {isEditing && !isLocalEditing && (
          <button 
            className="edit-btn"
            onClick={() => setIsLocalEditing(true)}
          >
            Edit
          </button>
        )}
        
        {isLocalEditing ? (
          <div className="edit-controls">
            <textarea
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              className="edit-textarea"
              rows="4"
            />
            <div className="edit-buttons">
              <button onClick={handleSave} className="save-btn">Save</button>
              <button onClick={handleCancel} className="cancel-btn">Cancel</button>
            </div>
          </div>
        ) : (
          <div className="content-display">
            <p>{content}</p>
          </div>
        )}
      </section>
    );
  }

  if (type === 'image') {
    return (
      <section className={`content-section image-section ${isEditing ? 'editable' : ''}`}>
        {isEditing && !isLocalEditing && (
          <button 
            className="edit-btn"
            onClick={() => setIsLocalEditing(true)}
          >
            Edit Image
          </button>
        )}
        
        {isLocalEditing ? (
          <div className="edit-controls">
            <input
              type="url"
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              placeholder="Enter image URL"
              className="edit-input"
            />
            <div className="edit-buttons">
              <button onClick={handleSave} className="save-btn">Save</button>
              <button onClick={handleCancel} className="cancel-btn">Cancel</button>
            </div>
          </div>
        ) : (
          <div className="content-display">
            <img src={content} alt={`Content for ${id}`} />
          </div>
        )}
      </section>
    );
  }

  return null;
};

export default ContentSection;